"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var components_1 = require("components");
var styled_components_1 = __importStar(require("styled-components"));
var ActionTypes_1 = require("../ActionTypes");
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
var components_2 = require("components");
var ToastLinkButton = styled_components_1.default(components_2.LinkButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.toast.link; });
var MsgIcon = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 24px;\t\n\twidth: 24px;\t\n\tpadding-right: 8px;\n\tfill: black;\n\tcolor: black;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\t", ";\n"], ["\n\theight: 24px;\t\n\twidth: 24px;\t\n\tpadding-right: 8px;\n\tfill: black;\n\tcolor: black;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\t", ";\n"])), function (props) { return props.theme.toast.icon; });
var IconMsg = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n\ttext-transform: uppercase;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tline-height: 26px;\n"], ["\n\t", ";\n\ttext-transform: uppercase;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tline-height: 26px;\n"])), function (props) { return props.theme.toast.item; });
// would be better if this was some sort of proper enum or similar?
var properActions = ["cancel", "added_accessory", "changed_feature", "removed_accessory", "screenshot", "delete", "savedBuild"];
var ToastContainer = /** @class */ (function (_super) {
    __extends(ToastContainer, _super);
    function ToastContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.generateToastMessage = function (data) {
            console.log("generateToastMessage", data);
            var object = { name: '', action: '', image: undefined, imageAspect: undefined, onClick: undefined, forModal: false };
            if (data.hasOwnProperty('action')) {
                var action = data.action;
                if (properActions.indexOf(action) >= 0) {
                    object.action = action;
                }
                else {
                    if (data.action.includes('warning')) {
                        object.action = "dbgWarn:";
                    }
                    else if (data.action.includes('error')) {
                        object.action = "dbgError:";
                    }
                    else {
                        object.action = "dbgInfo:";
                    }
                }
            }
            if (data.hasOwnProperty('item')) {
                if (data.item.hasOwnProperty('name')) {
                    object.name = data.item.name;
                }
                else if (data.item.hasOwnProperty('id') && data.item.id.hasOwnProperty('label')) {
                    object.name = data.item.id.label;
                }
                else if (data.item.hasOwnProperty('error')) {
                    object.name = data.item.error;
                }
            }
            object.image = data.image;
            object.imageAspect = data.imageAspect;
            object.onClick = data.onClick;
            object.forModal = data.modalOnly;
            return object;
        };
        _this.formatText = function (id, key, defaultStr, params) {
            var icons = _this.props.theme.svgs;
            return utils_1.formatMessage(_this.props.intl, {
                id: id,
                defaultMessage: defaultStr ? defaultStr : id
            }, __assign(__assign({}, params), { b: function (msg) { return (react_1.default.createElement("b", { key: key }, msg)); }, a: function (msg) { return (react_1.default.createElement(ToastLinkButton, { key: key, text: msg, onClick: params.onClick, automationId: "toastlink" })); }, icon: function (msg) {
                    return (react_1.default.createElement("span", null,
                        react_1.default.createElement(MsgIcon, { key: key }, icons.saved ? icons.saved : icons.info),
                        react_1.default.createElement(IconMsg, null, msg)));
                } }));
        };
        _this.state = {
            isOpen: false,
            action: 'test',
            item: 'test',
            appearance: 'add',
            text: null,
            allowdebug: window.zlurlparams.debug,
            showing: false,
            image: undefined,
            imageAspect: undefined,
            onClick: undefined
        };
        return _this;
    }
    ToastContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.toastQueue !== nextProps.toastQueue) {
            return true;
        }
        if (this.state.isOpen !== nextState.isOpen) {
            return true;
        }
        if (this.state.showing !== nextState.showing) {
            return true;
        }
        return false;
    };
    ToastContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (this.props.toastQueue.length > 0) {
            var queue = __spreadArrays(this.props.toastQueue);
            var queueIndex = 0;
            for (queueIndex = 0; queueIndex < queue.length; ++queueIndex) {
                var toastData = queue[queueIndex];
                if (properActions.includes(toastData.action)) {
                    if ((toastData.modalOnly === true) !== (this.props.modal === true)) {
                        continue;
                    }
                }
                break;
            }
            if (queueIndex >= queue.length) {
                return;
            }
            var toast = this.generateToastMessage(queue[queueIndex]);
            var actionIndex = properActions.indexOf(toast.action);
            var id = 'toast.' + (actionIndex >= 0 ? toast.action : 'text');
            console.log("adding toast ", id, toast);
            if (!this.state.showing || actionIndex === 0) {
                // doing the pop down here allows us to bail early if this particular bit of toast wasn't for us
                queue.splice(queueIndex, 1);
                this.props.dispatch({ type: ActionTypes_1.UPDATE_TOAST_QUEUE, data: queue });
                if (toast.action.includes('dbg') && !this.state.allowdebug) {
                    // don't show debug message
                }
                else {
                    if (actionIndex === 0) {
                        this.setState({ isOpen: false, showing: false });
                    }
                    else {
                        var action = toast.action;
                        if (actionIndex > 0 && actionIndex < 4) {
                            action = toast.action.toUpperCase().split("_")[0];
                        }
                        var text = this.formatText(id, toast.name, "<b>{action}</b> {name}", { action: action, name: toast.name.toUpperCase(), onClick: toast.onClick });
                        // Open
                        this.setState({ isOpen: true, text: text, showing: true, image: toast.image, imageAspect: toast.imageAspect, onClick: toast.onClick });
                        this.timeoutID = setTimeout(function () {
                            _this.timeoutID = setTimeout(function () {
                                // Begin close
                                _this.setState({ isOpen: false });
                                _this.timeoutID = setTimeout(function () {
                                    // Closed
                                    _this.setState({ showing: false });
                                    _this.timeoutID = undefined;
                                }, 400);
                            }, 3000);
                        }, 400);
                    }
                }
            }
        }
    };
    ToastContainer.prototype.componentWillUnmount = function () {
        if (this.timeoutID !== undefined) {
            clearTimeout(this.timeoutID);
            this.timeoutID = undefined;
        }
    };
    ToastContainer.prototype.render = function () {
        return (react_1.default.createElement("div", { id: "toast", "data-automationid": "toast", style: { position: 'absolute', left: 0, right: 0, bottom: 0, top: 0, overflow: 'hidden', pointerEvents: 'none', width: '100%', height: '100%', display: 'flex' } },
            react_1.default.createElement(components_1.Toast, { key: this.state.action, isOpen: this.state.isOpen, image: this.state.image, imageAspect: this.state.imageAspect, onClick: this.state.onClick, text: this.state.text, appearance: "add", placement: "left", forModal: this.props.modal })));
    };
    return ToastContainer;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        buildSession: store.BuildSession.current,
        toastQueue: store.ToastMessages.queue,
    };
};
var MapDispatchToProps = function (dispatch /*, ownProps:any*/) {
    return {
        dispatch: dispatch
    };
};
exports.default = react_redux_1.connect(MapStoreToProps, MapDispatchToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(ToastContainer)));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ToastContainer.js.map